// extracted by mini-css-extract-plugin
export var contactWrapper = "contact-module--contactWrapper--3aJVh";
export var contactForm = "contact-module--contactForm--qRiWv";
export var inputFields = "contact-module--inputFields--6rzJV";
export var successMessage = "contact-module--successMessage--8dHXN";